export default "<p-toast></p-toast>";